const numberValue = (value) => (value == null ? "" : value);

const StepFields = ({ step, path, onChange }) => (
  <div className="border border-dark-border p-2 space-y-2" data-testid={`step-${path.join("-")}`}>
    <div className="text-xs uppercase tracking-[0.12em] text-dark-text-secondary">
      {step.label || step.step_type} {step.repeat_count > 1 ? `· ${step.repeat_count}×` : ""}
    </div>
    <div className="flex flex-wrap gap-2">
      <label className="text-xs">
        Seconds
        <input
          className="mt-1 block w-24 border border-dark-border bg-dark-surface-1 px-2 py-1"
          aria-label={`${step.label || step.step_type} duration`}
          type="number"
          value={numberValue(step.duration_seconds)}
          onChange={(event) => onChange(path, { duration_seconds: Number(event.target.value) })}
        />
      </label>
      <label className="text-xs">
        Repeats
        <input
          className="mt-1 block w-20 border border-dark-border bg-dark-surface-1 px-2 py-1"
          aria-label={`${step.label || step.step_type} repeats`}
          type="number"
          value={numberValue(step.repeat_count)}
          onChange={(event) => onChange(path, { repeat_count: Number(event.target.value) })}
        />
      </label>
      {step.intensity ? (
        <>
          <label className="text-xs">
            Target low
            <input
              className="mt-1 block w-20 border border-dark-border bg-dark-surface-1 px-2 py-1"
              aria-label={`${step.label || step.step_type} target low`}
              type="number"
              value={numberValue(step.intensity.lower)}
              onChange={(event) => onChange(path, {
                intensity: { ...step.intensity, lower: Number(event.target.value) },
              })}
            />
          </label>
          <label className="text-xs">
            Target high
            <input
              className="mt-1 block w-20 border border-dark-border bg-dark-surface-1 px-2 py-1"
              aria-label={`${step.label || step.step_type} target high`}
              type="number"
              value={numberValue(step.intensity.upper)}
              onChange={(event) => onChange(path, {
                intensity: { ...step.intensity, upper: Number(event.target.value) },
              })}
            />
          </label>
        </>
      ) : null}
      {step.cadence_target ? (
        <label className="text-xs">
          Cadence
          <input
            className="mt-1 block w-20 border border-dark-border bg-dark-surface-1 px-2 py-1"
            aria-label={`${step.label || step.step_type} cadence`}
            type="number"
            value={numberValue(step.cadence_target.lower)}
            onChange={(event) => onChange(path, {
              cadence_target: {
                ...step.cadence_target,
                lower: Number(event.target.value),
                upper: Number(event.target.value),
              },
            })}
          />
        </label>
      ) : null}
    </div>
    {(step.substeps || []).map((child, index) => (
      <StepFields
        key={`${path.join("-")}-${index}`}
        step={child}
        path={[...path, "substeps", index]}
        onChange={onChange}
      />
    ))}
  </div>
);

export const WorkoutStepEditor = ({ sections, onChange }) => (
  <div className="space-y-3" data-testid="advanced-customize">
    {["warmup", "main_set", "cooldown"].map((key) => (
      <div key={key}>
        <h3 className="mb-2 text-xs tracking-[0.16em] uppercase text-dark-text-secondary">{key.replace("_", " ")}</h3>
        {(sections?.[key] || []).map((step, index) => (
          <StepFields key={`${key}-${index}`} step={step} path={[key, index]} onChange={onChange} />
        ))}
      </div>
    ))}
  </div>
);
